import ToPayOutGridWarnings from './js/ToPayOutGridWarnings';

export default ToPayOutGridWarnings;
